import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Slider from "react-slick";
import NumberFormat from "react-number-format";
import Select from "react-select";
import * as moment from "moment";
import "moment-duration-format";

import SwitchOnOff from "components/common/tools/SwitchOnOff";
import LangSelector from "components/utils/LangSelector";

import "css/admin/signup.scss";
import "slick-carousel/slick/slick.scss";

export class SignupStep1UI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plans: props.formated_plans ? props.formated_plans : [],
      selected_plan: props.selected_plan_default
        ? props.selected_plan_default
        : null,
      selected_plan_option: props.selected_plan_option_default
        ? props.selected_plan_option_default
        : null,
      active_options: props.active_options_default
        ? props.active_options_default
        : [],
      screenMode: "dekstop",
    };
  }

  componentDidMount() {
    this.initPlans(this.props.plans);
    this.updateDimensions();

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate() {
    this.initPlans(this.props.plans);
  }

  updateDimensions = () => {
    // 900 is a magic number that defines hte width of screen when to pass to mobile mode
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let screenMode = this.carousel.clientWidth <= 900 ? "tablet" : "dekstop";
      screenMode = this.carousel.clientWidth <= 600 ? "mobile" : screenMode;

      if (this.state.screenMode != screenMode) {
        this.setState({
          screenMode,
        });
      }
    }, 500);
  };

  initPlans = (plans) => {
    if (this.state.plans.length <= 0 && plans && plans.data.length > 0) {
      const plans_formated = this.getPlans(plans);
      this.setState({
        plans: plans_formated,
        selected_plan: !this.state.selected_plan
          ? plans_formated.start.uuid
          : this.state.selected_plan,
        selected_plan_option: !this.state.selected_plan_option
          ? plans_formated.start.options[0].uuid
          : this.state.selected_plan_option,
      });
    }
  };

  getPlans = (plans) => {
    const { t } = this.props;
    const formated_plans = {};
    const plans_enum = ["tiny", "start", "run", "fly"];

    if (plans.indexes.label) {
      plans_enum.forEach((e) => {
        const plans_indexes = plans.indexes.label[e];
        const plan_item = plans.data[plans_indexes[0]];
        const options = [];
        plans_indexes.forEach((i) => {
          const plan_details = plans.data[i];
          options.push({
            price: plan_details.price,
            max_encoding_sec: plan_details.max_encoding_sec,
            fee_pct: plan_details.fee_pct,
            uuid: plan_details.uuid,
          });
        });

        plan_item.options = options;
        plan_item.selected_option = {
          uuid: options[0].uuid,
          max_encoding_sec: options[0].max_encoding_sec,
          price: options[0].price,
          fee_pct: options[0].fee_pct,
          label: `${t(`plan_label_${e}`)} ${this.formatDuration(
            options[0].max_encoding_sec,
          )} ${t("hours")}`,
        };
        formated_plans[e] = plan_item;
      });
    }

    return formated_plans;
  };

  getArrow(position) {
    return (
      <div key={position} className={`signup-plans-arrow ${position}`}>
        <i className="material-icons">{`keyboard_arrow_${position}`}</i>
      </div>
    );
  }

  onEncodingSec = (selection, plan) => {
    const { t } = this.props;
    plan.selected_option = {
      uuid: selection.value,
      max_encoding_sec: selection.max_encoding_sec,
      price: selection.price,
      fee_pct: selection.fee_pct,
      label: `${t(`plan_label_${plan.label}`)} ${this.formatDuration(
        selection.max_encoding_sec,
      )} ${t("hours")}`,
    };

    const { plans } = this.state;
    plans[plan.label] = plan;

    this.setState({
      plans,
      selected_plan: plan.uuid,
      selected_plan_option: selection.value,
    });
  };

  getEncodingSec = (plan) => {
    const { t } = this.props;

    const objPlans = [];

    if (plan && plan.options) {
      plan.options.forEach((opt) => {
        objPlans.push({
          value: opt.uuid,
          label: `${this.formatDuration(opt.max_encoding_sec)} ${t("hours")}`,
          max_encoding_sec: opt.max_encoding_sec,
          price: opt.price,
          fee_pct: opt.fee_pct,
        });
      });
    }

    return objPlans;
  };

  formatDuration = (seconds) => {
    const totalDuration = moment.duration(seconds, "seconds");
    const total = totalDuration.format("hh", { trim: false });

    return total;
  };

  getPlansElement = (plans) => {
    const { t } = this.props;
    const { selected_plan } = this.state;
    const plansElements = [];
    const plansBandwidthPrice = {
      tiny: "0.20",
      start: "0.18",
      run: "0.15",
      fly: "0.10",
    };

    for (const key in plans) {
      const plan = plans[key];
      plansElements.push(
        <div
          className={`signup-plan ${selected_plan === plan.uuid ? "plan-selected" : ""}`}
          key={`plan-${key}`}
          onClick={() => this.selectPlan(plan)}
        >
          <div className="signup-plan-title">
            {t(`plan_title_${plan.label}`)}
          </div>
          <div className="signup-plan-price">
            <div className="signup-plan-price-mount">
              {plan.selected_option.price}€
            </div>
            <div className="signup-plan-price-period">
              <div className="signup-plan-period-item">{t("per")}</div>
              <div className="signup-plan-period-item">{t("month")}</div>
            </div>
          </div>
          {key === "tiny" && (
            <div className="signup-plan-tip">{t("moneyback_warranty")}</div>
          )}
          <div className="signup-plan-subtitle">
            {t("plan_subtitle", { per: plan.selected_option.fee_pct })}
          </div>
          <div className="signup-plan-details signup-plan-details-important">
            <NumberFormat
              value={plan.max_user}
              displayType="text"
              thousandSeparator={" "}
            />
            <span className="signup-plan-details-users">{t("users")}</span>
          </div>
          <div className="signup-plan-details editor-tooltip editor-tooltip-center editor-tooltip-multiline">
            <Select
              name="plan-encoding-select"
              closeMenuOnSelect
              value={
                plan.selected_option
                  ? {
                      value: plan.selected_option.uuid,
                      label: `${this.formatDuration(
                        plan.selected_option.max_encoding_sec,
                      )} ${t("hours")}`,
                    }
                  : null
              }
              onChange={(selection) => this.onEncodingSec(selection, plan)}
              options={this.getEncodingSec(plan)}
              placeholder={t("select")}
              className="editor-select"
              classNamePrefix="slct"
            />
            <span className="editor-tooltiptext">{t("bandwidthTooltip")}</span>
          </div>
          <div className="signup-plan-details">
            {plan.bandwidth_allowed_go >= 1000 &&
              `${t("bandwidth_price", {
                size: (plan.bandwidth_allowed_go / 1000).toFixed(0),
                price: plansBandwidthPrice[key],
              })}`}

            {plan.bandwidth_allowed_go < 1000 &&
              `${t("bandwidth_price", {
                size: (plan.bandwidth_allowed_go / 1000).toFixed(1),
                price: plansBandwidthPrice[key],
              })}`}
          </div>
          <div className="signup-plan-details">
            {t(`plan_livefeature_${key !== "tiny"}`)}
          </div>
          <div className="signup-plan-label">
            {t(`plan_label_${plan.label}`)}
          </div>
        </div>,
      );
    }

    plansElements.push(this.addVIPPlan());

    return plansElements;
  };

  addVIPPlan() {
    const { t } = this.props;
    return (
      <div
        className="signup-plan signup-plan-vip"
        key="plan-vip"
        onClick={() => this.selectVIPPlan()}
      >
        <div className="signup-plan-title">{t(`plan_pretitle_vip`)}</div>
        <div className="signup-plan-price">
          <div className="signup-plan-price-mount">{t(`plan_title_vip`)}</div>
        </div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt1`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt2`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt3`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt4`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt5`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt6`)}</div>
        <div className="signup-plan-details">{t(`plan_title_vip_opt7`)}</div>
        <div className="signup-plan-label">{t("plan_label_vip")}</div>
      </div>
    );
  }

  selectPlan = (plan) => {
    this.setState({
      selected_plan: plan.uuid,
      selected_plan_option: plan.selected_option.uuid,
    });
  };

  selectVIPPlan = () => {
    window.open("mailto:hello@okast.tv");
  };

  onChangeOpt = (opt, value) => {
    const { active_options } = this.state;

    active_options[opt] = value;
    this.setState({
      active_options,
    });
  };

  onSubmit = () => {
    const { onChoosePlan } = this.props;
    const { selected_plan, selected_plan_option, active_options, plans } =
      this.state;

    onChoosePlan(selected_plan, active_options, selected_plan_option, plans);
  };

  render() {
    const { t, plan_options } = this.props;
    const { plans, active_options, screenMode } = this.state;

    const settings = {
      dots: false,
      useTransform: false,
      infinite: false,
      speed: 500,
      slidesToShow:
        screenMode === "mobile" ? 1 : screenMode === "tablet" ? 2 : 3,
      slidesToScroll:
        screenMode === "mobile" || screenMode === "tablet" ? 1 : 2,
      nextArrow: this.getArrow("right"),
      prevArrow: this.getArrow("left"),
    };

    const plan_opts_links = {
      sponso:
        "https://support.okast.tv/en/support/solutions/articles/103000101417-video-display-sponsoring-features-details-and-examples-of-use",
      playlist:
        "https://support.okast.tv/en/support/solutions/articles/103000101792-allow-your-users-to-create-their-own-custom-playlists",
    };

    return (
      <div className="signup-step-container">
        <div
          className="signup-plans-container"
          ref={(el) => {
            this.carousel = el;
          }}
        >
          <Slider {...settings}>{this.getPlansElement(plans)}</Slider>
          <div className="signup-plans-subtitle">{t("plans-subtitle")}</div>
        </div>
        <div className="signup-plan-options-container">
          <div className="signup-plan-options-title">
            {t("plan_options_title")}
          </div>
          <div className="signup-plan-options">
            {plan_options.data.map((option, index) => (
              <div className="signup-plan-option" key={`option-${index}`}>
                <div className="signup-plan-option-switch">
                  <SwitchOnOff
                    name={`activate_option-${index}`}
                    iconName=""
                    checked={active_options[option.uuid]}
                    size="xs"
                    onChange={(value) => this.onChangeOpt(option.uuid, value)}
                  />
                </div>
                <div className="signup-plan-option-title">
                  {plan_opts_links[option.type] ? (
                    <a
                      href={plan_opts_links[option.type]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(option.type)}
                    </a>
                  ) : (
                    t(option.type)
                  )}
                </div>
                <div className="signup-plan-option-price-container">
                  <div className="signup-plan-option-price">
                    {option.price}€{" "}
                    {option.recurrency === 1 ? `/ ${t("month")}` : ""}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="signup-btn-container">
          <div className="signup-btn-wrapper">
            <div>
              <div className="signup-btn-confirm" onClick={this.onSubmit}>
                <span>{t("btn_confirm_step1")}</span>
              </div>
            </div>
            <LangSelector languages={["en", "fr"]} />
          </div>
        </div>
      </div>
    );
  }
}

SignupStep1UI.propTypes = {
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  plans: PropTypes.object.isRequired,
  plan_options: PropTypes.object.isRequired,
  onChoosePlan: PropTypes.func.isRequired,
  selected_plan_default: PropTypes.string,
  selected_plan_option_default: PropTypes.string,
  active_options_default: PropTypes.array,
  formated_plans: PropTypes.array,
};

const mapStateToProps = (state) => {
  const { token } = state.loginReducer;
  const { plans, plan_options } = state.fetchReducer;
  const { lang } = state.variableReducer.lang;
  return {
    token,
    plans,
    lang,
    plan_options,
  };
};

export default connect(mapStateToProps)(
  withTranslation("editor-signup")(SignupStep1UI),
);
